import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';
import { SWRConfig } from 'swr';

import { cookieJar, swrConfig } from '@consumer-frontend/api';
import { OptimizelyWrapper } from '@consumer-frontend/optimizely';

import { App } from './app/App';
import './utils/analytics';

async function enableMocking() {
  if (
    import.meta.env.VITE_ENV === 'development'
    && import.meta.env.VITE_MOCKING === 'true'
  ) {
    // eslint-disable-next-line import/extensions
    const { startWorker } = await import('./mocks/browser');

    // Awaited so the first render cannot fetch before the worker can intercept.
    await startWorker();
  }
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  // Read synchronously out of the access-token JWT, so this adds no network wait.
  // The error arm is ignored: OptimizelyWrapper already degrades to bare children
  // when there is no id, which is the same outcome.
  const [accountId] = cookieJar.getAccountId();

  root.render(
    <StrictMode>
      <SWRConfig value={swrConfig}>
        <OptimizelyWrapper user={{ id: accountId }}>
          <App />
        </OptimizelyWrapper>
      </SWRConfig>
    </StrictMode>,
  );
});
